import rehypeReact from "rehype-react";
import ReactMarkdown from "react-markdown";

export const ReactMarkdownAI = ({ message }: { message: string }) => {
  return (
    <ReactMarkdown
      children={message}
      rehypePlugins={[rehypeReact]}
      className="answer-ai-container clamp-6"
    />
  );
};
